import React from "react";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {FTUTrans} from 'components/FTUComponent';

export var showMessageBox = async function (
    _message,
    _title = <FTUTrans ns="common" name="msg.title"/>,
    _func,
    _style = {width: "30%", top: "30%"}
) {
    await this.setState({
        open: true,
        color: "modal-primary",
        showConfirmBtn: false,
        title: _title,
        message: _message,
        onClose: _func,
        style: _style
    });
    let focus = setInterval(() => {
        if (document.getElementById("btnCloseMessage")) {
            document.getElementById("btnCloseMessage").focus();
        } else {
            clearInterval(focus);
        }
    }, 5);
};

export var showErrorBox = async function (
    _message,
    _title = <FTUTrans ns="common" name="msg.title"/>,
    _func,
    _style = {width: "30%", top: "30%"}
) {
    await this.setState({
        open: true,
        color: "modal-danger",
        showConfirmBtn: false,
        title: _title,
        message: _message,
        onClose: _func,
        style: _style
    });
    let focus = setInterval(() => {
        if (document.getElementById("btnCloseMessage")) {
            document.getElementById("btnCloseMessage").focus();
        } else {
            clearInterval(focus);
        }
    }, 5);
};

export var showWarningBox = async function (
    _message,
    _title = <FTUTrans ns="common" name="msg.title"/>,
    _func,
    _style = {width: "30%", top: "30%"}
) {
    await this.setState({
        open: true,
        color: "modal-warning",
        showConfirmBtn: false,
        title: _title,
        message: _message,
        onClose: _func,
        style: _style
    });
    let focus = setInterval(() => {
        if (document.getElementById("btnCloseMessage")) {
            document.getElementById("btnCloseMessage").focus();
        } else {
            clearInterval(focus);
        }
    }, 5);
};

export var showConfirm = async function (
    _message,
    _onConfirm,
    _title = <FTUTrans ns="common" name="msg.confirm"/>,
    _style = {width: "30%", top: "30%"}
) {
    await this.setState({
        open: true,
        color: "modal-primary",
        showConfirmBtn: true,
        title: _title,
        message: _message,
        onConfirm: _onConfirm,
        style: _style
    });
    document.getElementById("btnConfirmYes").focus();
};

class MessageBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            showConfirmBtn: false,
            style: {width: "30%", top: "30%"}
        };
        showMessageBox = showMessageBox.bind(this);
        showErrorBox = showErrorBox.bind(this);
        showWarningBox = showWarningBox.bind(this);
        showConfirm = showConfirm.bind(this);
    }

    onClose = () => {
        this.setState({open: false});
        if (this.state.onClose) {
            this.state.onClose();
        }
    };

    onConfirm = () => {
        this.setState({open: !this.state.open});
        this.state.onConfirm();
    };

    // componentDidUpdate(prevProps, prevState, snapshot) {
    //     if (this.state.open) {
    //         if (document.getElementById("btnCloseMessage")) {
    //             document.getElementById("btnCloseMessage").focus();
    //         }
    //     }
    // }

    render() {
        return (
            <div>
                <Modal style={this.state.style ? this.state.style : {width: "30%", top: "30%"}}
                       id={"messageBox"}
                       isOpen={this.state.open}
                       toggle={this.onClose}
                       backdrop="static"
                       className={this.state.color}>
                    <ModalHeader toggle={this.onClose}>{this.state.title}</ModalHeader>
                    <ModalBody>{this.state.message}</ModalBody>
                    <ModalFooter>
                        <Button color="primary"
                                id={"btnConfirmYes"}
                                onClick={this.onConfirm}
                                hidden={!this.state.showConfirmBtn}>
                            <FTUTrans ns="common" name="msg.btnYes"/>
                        </Button>
                        <Button color="primary"
                                onClick={this.onClose}
                                hidden={!this.state.showConfirmBtn}>
                            <FTUTrans ns="common" name="msg.btnNo"/>
                        </Button>
                        <Button color="primary"
                                id={"btnCloseMessage"}
                                onClick={this.onClose}
                                hidden={this.state.showConfirmBtn}>
                            <FTUTrans ns="common" name="msg.btnClose"/>
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default (MessageBox);
